import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { 
  getIsVerified, 
  setIsVerified as setIsVerifiedStorage,
  getIsFillProfile,
  setIsFillProfile as setIsFillProfileStorage
} from "./verificationStorage";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [isVerified, setIsVerified] = useState(() => getIsVerified());

  const [isFillProfile, setIsFillProfile] = useState(() => getIsFillProfile());
  
  const [notificationList, setNotificationList] = useState([]);
  const [messageNotify, setMessageNotify] = useState([]); // Про мои галочки в обратной связи

  const [totalQuantity, setTotalQuantity] = useState('');

  const [isShowWarning, setIsShowWarning] = useState(false);
  const [messageWarning, setMessageWarning] = useState({
    title: '',
    description: ''
  });

  useEffect(() => {
    setIsVerifiedStorage(isVerified);
  }, [isVerified]);

  useEffect(() => {
    setIsFillProfileStorage(isFillProfile);
  }, [isFillProfile]);

  const resetUserSession = () => {
    setIsVerified(false);
    setIsFillProfile(false);

    localStorage.removeItem('isVerified');
    localStorage.removeItem('isFillProfile');
    localStorage.removeItem('email');
  }

  const value = useMemo(
    () => ({ 
      isVerified, 
      setIsVerified,

      isFillProfile,
      setIsFillProfile,

      isShowWarning,
      setIsShowWarning,

      messageWarning,
      setMessageWarning,

      notificationList,
      setNotificationList,

      messageNotify,
      setMessageNotify,

      totalQuantity,
      setTotalQuantity,

      resetUserSession
     }),
    [isVerified, isFillProfile, isShowWarning, messageWarning, notificationList, messageNotify, totalQuantity]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => useContext(AuthContext);